import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Code2, Radar, Sparkles } from 'lucide-react';
import { profile } from '../data/profile';
import { fadeUp, chipPop, staggerContainer } from '../lib/motion';
import TextReveal from './TextReveal';
import './About.css';

const highlights = [
  { icon: Radar, title: 'Hardware & sensors', text: 'Radar, ESP32, Raspberry Pi, and servos. Edge AI that runs without the cloud.' },
  { icon: Cpu, title: 'Machine learning', text: 'Computer vision, predictive models, and NLP applied to real-world problems.' },
  { icon: Code2, title: 'Full-stack web', text: 'React frontends and Python/Flask backends that tie the whole thing together.' },
  { icon: Sparkles, title: 'Ship fast', text: 'Weekend prototypes that actually work, and sometimes win.' },
];

const About = () => {
  return (
    <section className="section about" id="about">
      <div className="container">
        <div className="section-head">
          <motion.span
            className="eyebrow"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: '-60px' }}
          >
            About
          </motion.span>
          <TextReveal as="h2" className="section-title" text="Engineer who ships" mode="words" inView />
        </div>

        <div className="about__grid">
          <motion.div
            className="about__bio"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6 }}
          >
            {profile.about.map((para, i) => (
              <p key={i}>{para}</p>
            ))}

            <div className="about__skills">
              <h3 className="about__skills-title">Toolbox</h3>
              <motion.div
                className="about__chips"
                variants={staggerContainer(0.04)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: '-40px' }}
              >
                {profile.skills.map((s) => (
                  <motion.span className="chip" key={s} variants={chipPop}>{s}</motion.span>
                ))}
              </motion.div>
            </div>
          </motion.div>

          <div className="about__cards">
            {highlights.map((h, i) => (
              <motion.div
                key={h.title}
                className="about__card glass gradient-border"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
              >
                <div className="about__card-icon">
                  <h.icon size={20} />
                </div>
                <h4>{h.title}</h4>
                <p>{h.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
